import { searchQueryIsNotEmpty } from "../../../utils/searchQuery";
import {PathPickerType} from "../../../types/enums";
import { FormHelperText } from "@mui/material";
import { SelectableSite } from "../../../types/types";
import { Grid, Switch } from "@mui/material";
import TextField from "../../../../TextField";
import Button from "../../../../Button";

interface SearchProps {
  fetchContent: Function;
  setProperty: Function;
  searchQuery: string;
  loadingContent: boolean;
  type: PathPickerType;
  switchValue: boolean;
  currentSite: SelectableSite;
}

export default class Search extends window.React.PureComponent<SearchProps> {
  onSearchFieldChange = async (event: React.ChangeEvent) => {
    const newSearchQuery: string = (event.target as HTMLInputElement).value;

    const { fetchContent, setProperty } = this.props;

    await setProperty("searchQuery", newSearchQuery);

    //If the user cleared the input, fetch content of the last open folder, if any.
    if (newSearchQuery.length === 0) {
      fetchContent();
    }
  };
  onSwitchChange = () => {
    const {switchValue, setProperty} = this.props;
    setProperty("switchValue", !switchValue);
  }

  onSearch = () => {
    const { searchQuery, fetchContent } = this.props;

    fetchContent(searchQuery);
  };

  onKeyUp = (event: React.MouseEvent) => {
    event.persist();
    if (event.keyCode === 13) {
      this.onSearch();
    }
  };

  render() {
    const { searchQuery, loadingContent, type, switchValue, currentSite } = this.props;
    const isSearchQueryValid = searchQueryIsNotEmpty(searchQuery);

    return (
      <div className="structure-item search">
        <TextField
          label={window.Alfresco.messages.global[`edocat.global.path-picker.search-${type === PathPickerType.FOLDER ? 'folder' : 'all'}`]}
          placeholder={window.Alfresco.messages.global['edocat.global.path-picker.search-placeholder']}
          value={searchQuery}
          onChange={this.onSearchFieldChange}
          onKeyUp={isSearchQueryValid ? this.onKeyUp : null}
          autoFocus
          type="search"
          disabled={loadingContent}
        />
        {searchQuery && currentSite.nodeRef !== "" &&
          <div className="gridDiv">
            <FormHelperText style={{marginBottom: "-9px"}}>{window.Alfresco.messages.global['edocat.global.path-picker.search-searchin']}</FormHelperText>
            <Grid component="label" container alignItems="center" spacing={1}>
              <Grid item>{window.Alfresco.messages.global['edocat.global.path-picker.search-current-path']}</Grid>
              <Grid item>
                <Switch
                  checked={switchValue}
                  onChange={this.onSwitchChange}
                  value="checked"
                  color="primary"
                />
              </Grid>
              <Grid item>{window.Alfresco.messages.global['edocat.global.path-picker.search-whole-space']}</Grid>
            </Grid>
          </div>
        }
        <Button
          primary
          label={window.Alfresco.messages.global['button.search']}
          onClick={this.onSearch}
          disabled={!isSearchQueryValid || loadingContent}
        />
      </div>
    );
  }
}
